import HoverQrcode from "@components/HoverQrcode";
export default {
  name: "Floor",
  props: ["showCode", "fixed", "scrollElement","absolute"],
  components: {
    HoverQrcode,
  },
  data() {
    this.callBack = null;
    this.domObserve = null;
    return {
      noScroll: true,
      years: 2022
    };
  },
  mounted() {
    if (this.fixed) {
      this.callBack = () => {
        this.setHolder();
        this.setFixed();
      };
      this.domObserve = new MutationObserver((mutationsList) => {
        if (mutationsList.length) {
          this.setHolder();
          this.setFixed();
        }
      });
      this.domObserve.observe(document.body, {
        childList: true,
        subtree: true,
      });
      window.addEventListener("resize", this.callBack, true);
      this.setHolder();
      this.setFixed();
    }
    if (this.absolute) {
      this.setHolder();
    }
    let d = new Date();
    this.years = +d.getFullYear();
  },
  unMounted() {
    if (this.fixed) {
      this.domObserve.disconnect();
      window.removeEventListener("resize", this.callBack);
    }
  },
  methods: {
    setFixed() {
      let el =
        this.scrollElement ||
        document.scrollingElement ||
        document.documentElement;
      this.noScroll = el.scrollHeight > el.offsetHeight;
    },
    goICP() {
      window.open("http://beian.miit.gov.cn");
    },
    setHolder() {
      let {
        holder,
        floor
      } = this.$refs;
      if (holder) {
        holder.style.height = floor.clientHeight + "px";
      }
    },
    // goDy:utils.throttle(function() {
    //   let w1 = window.open();
    //   setTimeout(() => {
    //     w1.location = "snssdk1128://user/profile/66615107645";
    //     setTimeout(() => {
    //       w1.location = "https://v.douyin.com/euAEACS/";
    //     }, 100);
    //   }, 300);
    // }),
    // goWb:utils.throttle(function() {
    //   // window.open("https://weibo.com/u/6563374966", "_blank");
    //   // window.open("ibeiliao://", "_blank");
    //   let w1 = window.open();
    //   setTimeout(() => {
    //     w1.location = "ibeiliao://";
    //     setTimeout(() => {
    //       w1.location = "https://weibo.com/u/6563374966";
    //     }, 100);
    //   }, 300);
    // }),
  },
};
